<template>
  <div>
    <div class="relative flex justify-center w-full py-24 overflow-hidden md:pb-16 md:pt-6 md:items-center hero header-height-top-space viewport-gutter">
      <div class="w-full md:my-auto">
        <div class="container w-full text-white">
          <div class="w-full max-w-68 md:max-w-xl xl:max-w-4xl">
            <h1 class="text-2.5xl leading-tight font-bold pb-5 md:text-4xl xl:pb-7">
              {{ tr('pages.sales.landing.hero.title') }}
            </h1>
          </div>
          <div class="md:max-w-xl xl:max-w-3xl">
            <p class="text-lg font-normal md:text-xl xl:text-2xl">
              {{ tr('pages.sales.landing.hero.subtitle') }}
            </p>
          </div>

          <div class="pt-7 xl:pt-14">
            <div class="max-w-68">
              <Button
                id="hero-action-button"
                :href="$i18nTo({ name: 'voucherSaleAmount' })"
                variant="primary"
                full-width
              >
                {{ tr('pages.sales.landing.hero.button') }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="relative -mt-12 pb-14 viewport-gutter xl:pb-20">
      <div class="container">
        <div class="flex flex-col px-4 py-5 bg-white border border-gray-300 md:flex-row md:py-6 xl:px-10 xl:pb-8 xl:pt-9">
          <div class="flex mb-5 md:w-1/3 md:mb-0 md:mr-6 xl:mr-10">
            <div class="flex-shrink-0 mr-3">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.364 10.182c.602 0 1.09-.489 1.09-1.091V5.455a1.091 1.091 0 00-2.181 0V9.09c0 .602.488 1.09 1.09 1.09z" fill="#333"/><path d="M25.455 7.273V9.09a1.818 1.818 0 11-3.637 0V7.273H10.182V9.09a1.818 1.818 0 11-3.637 0V7.273H4.364v18.909c0 .8.654 1.454 1.454 1.454h20.364c.8 0 1.455-.653 1.455-1.453V7.273h-2.182zm.727 18.908l-.004.002H5.822l-.003-.002-.002-13.09h20.366l-.001 13.09z" fill="#333"/><path d="M23.636 10.182c.603 0 1.091-.489 1.091-1.091V5.455a1.091 1.091 0 00-2.182 0V9.09c0 .602.489 1.09 1.091 1.09zM13.497 14.546h-2.49v2.548h2.49v-2.549zM17.23 14.546h-2.489v2.548h2.49v-2.549zM20.965 14.546h-2.49v2.548h2.49v-2.549zM9.762 18.369h-2.49v2.549h2.49v-2.55zM13.497 18.369h-2.49v2.549h2.49v-2.55zM17.23 18.369h-2.489v2.549h2.49v-2.55zM24.698 14.546h-2.49v2.548h2.49v-2.549zM24.698 18.369h-2.49v2.549h2.49v-2.55zM9.762 22.186h-2.49v2.55h2.49v-2.55zM13.497 22.186h-2.49v2.55h2.49v-2.55zM17.23 22.186h-2.489v2.55h2.49v-2.55zM20.965 22.186h-2.49v2.55h2.49v-2.55zM18.93 20.933l.782-.783.783.783.508-.508-.783-.783.783-.783-.508-.508-.783.783-.783-.783-.508.508.783.783-.783.783.508.508z" fill="#333"/></svg>
            </div>
            <div class="leading-snug">
              <p class="pb-1 text-base font-bold md:pb-2 xl:text-2xl">
                {{ tr('pages.sales.landing.benefit.one.title') }}
              </p>
              <p class="text-sm leading-normal xl:text-base">
                {{ tr('pages.sales.landing.benefit.one.description') }}
              </p>
            </div>
          </div>
          <div class="flex mb-5 md:w-1/3 md:mb-0 md:mr-6 xl:mr-10">
            <div class="flex-shrink-0 mr-3">
              <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.667 2.91C9.437 2.91 3.576 8.77 3.576 16c0 7.23 5.86 13.09 13.09 13.09 7.23 0 13.092-5.86 13.092-13.09 0-7.23-5.861-13.09-13.091-13.09zm-8.068 21.5A11.578 11.578 0 015.013 16c0-.9.103-1.783.3-2.638l.81.82.726.727.364.364.727.727-1.09 1.09v1.092l1.75 1.765v4.463zm17.148-10.592h-2.535l-.727-.727h-2.91l-2.153 2.182v1.868L23.161 24l-.002 1.682a11.571 11.571 0 01-6.492 1.972c-2.37 0-4.63-.703-6.546-2.009V24l3.637-4.364v-1.454l-2.546-2.546H9.03l-1.454-1.454V13.09l1.454-1.455h1.455l3.273-3.272V4.71c.939-.24 1.914-.365 2.909-.365 2.588 0 5.046.838 7.067 2.386l-.526.51h-1.827v2.576h-1.809V12h2.182l1.454-1.455h1.455l1.303 1.314-.219 1.96zm1.076.702l.338-.338.852-.857c.203.867.308 1.763.308 2.675v.028l-1.498-1.508z" fill="#333"/></svg>
            </div>
            <div class="leading-snug">
              <p class="pb-1 text-base font-bold md:pb-2 xl:text-2xl">
                {{ tr('pages.sales.landing.benefit.two.title') }}
              </p>
              <p class="text-sm leading-normal xl:text-base">
                {{ tr('pages.sales.landing.benefit.two.description') }}
              </p>
            </div>
          </div>
          <div class="flex md:w-1/3">
            <div class="flex-shrink-0 mr-3">
              <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.934 13.082h.001l.806-.8c.504-.402 1.005-.297 1.005-.297.963.157 1.08 1.045 1.08 1.045.117 1.287-1.06 1.472-1.06 1.472l-.01.026h15.642v-4.346c0-.8-.655-1.455-1.455-1.455H11.934v4.355zM8.64 14.528l-.009-.026s-1.178-.185-1.06-1.473c0 0 .116-.887 1.079-1.044 0 0 .501-.104 1.006.296l.805.8V8.728H4.689c-.8 0-1.454.655-1.454 1.455v4.346H8.64zM13.309 16l1.172 1.172v2.057l-2.547-2.535v5.107h16.01c.8 0 1.454-.655 1.454-1.455V16h-16.09zM10.462 16.694L7.916 19.23v-2.057L9.087 16H3.234v4.346c0 .8.654 1.455 1.454 1.455h5.774v-5.107z" fill="#333"/></svg>
            </div>
            <div class="leading-snug">
              <p class="pb-1 text-base font-bold md:pb-2 xl:text-2xl">
                {{ tr('pages.sales.landing.benefit.three.title') }}
              </p>
              <p class="text-sm leading-normal xl:text-base">
                {{ tr('pages.sales.landing.benefit.three.description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-12 md:px-6 lg:px-8 xl:px-20 xl:mb-20 text-sn-gray-900">
      <div class="container">
        <h2 id="get-voucher" class="px-4 pb-4 text-xl font-bold md:pb-6 md:text-2xl md:px-0 xl:text-3xl">
          {{ tr('pages.sales.landing.types.title') }}
        </h2>
        <div class="flex px-4 py-4 overflow-x-auto md:justify-start md:overflow-x-visible md:py-0 md:px-0">
          <TypeCard
            :title="tr('pages.sales.landing.types.digital.title')"
            class="mr-6 xl:mr-14"
          >
            <template v-slot:image>
              <img
                srcset="~images/swiss/offers/digital-voucher@2x.jpg 2x, ~images/swiss/offers/digital-voucher.jpg 1x "
                src="~images/swiss/offers/digital-voucher.jpg"
              >
            </template>

            <p class="text-sm xl:text-base">
              {{ tr('pages.sales.landing.types.digital.benefit') }}
            </p>

            <template v-slot:buttons>
              <Button
                variant="primary"
                :href="$i18nTo({ name: 'voucherSaleAmount' })"
              >
                {{ tr('pages.sales.landing.types.digital.button') }}
              </Button>
            </template>
          </TypeCard>

          <TypeCard :title="tr('pages.sales.landing.types.existing.title')">
            <template v-slot:image>
              <img
                srcset="~images/swiss/offers/digital-voucher-app@2x.jpg 2x, ~images/swiss/offers/digital-voucher-app.jpg 1x"
                src="~images/swiss/offers/digital-voucher-app.jpg"
              >
            </template>

            <p class="text-sm xl:text-base">
              {{ tr('pages.sales.landing.types.existing.description') }}
            </p>

            <template v-slot:buttons>
              <Button
                variant="secondary"
                :href="swissComUrl"
              >
                {{ tr('pages.sales.landing.types.existing.button.redeem') }}
              </Button>
            </template>
          </TypeCard>
        </div>
      </div>
    </div>
    <div class="container mb-12 xl:mb-20">
      <HowItWorks />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import HowItWorks from '~brand-components/swiss/sale-landing-page/how-it-works.vue'
import Button from '~brand-components/swiss/button/button.vue'
import TypeCard from '~brand-components/swiss/type-card/type-card.vue'

export default Vue.extend({
  components: {
    Button,
    HowItWorks,
    TypeCard,
  },
  computed: {
    swissComUrl() {
      const locale = this.$i18n.locale
      if (['de', 'fr', 'it'].includes(locale)) {
        return `https://www.swiss.com/ch/${locale}`
      }
      return 'https://www.swiss.com/ch/en'
    },
  },
})
</script>

<style lang="scss" scoped>
.hero {
  min-height: 490px;
  background: url("../../images/swiss/hero-sale/mobile.jpg") right top / cover no-repeat;

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    background-image: url("../../images/swiss/hero-sale/mobile@2x.jpg");
  }
}

@screen md {
  .hero {
    min-height: 630px;
    background: url("../../images/swiss/hero-sale/tablet.jpg") center center / cover no-repeat;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      background-image: url("../../images/swiss/hero-sale/tablet@2x.jpg");
    }
  }
}

@screen xl {
  .hero {
    background: url("../../images/swiss/hero-sale/desktop.jpg") center center / cover no-repeat;
    min-height: 628px;
    aspect-ratio: 1440 / 628;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      background-image: url("../../images/swiss/hero-sale/desktop@2x.jpg");
    }
  }

}
</style>
